import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: 'calc(100vh - 24rem)'
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '50%',
        zIndex: 2,
        '& p': {
            margin: theme.spacing(0, 'auto', 5)
        },
        '& > p > a': {
            color: theme.palette.primary.light
        },
        '& > p > a:hover': {
            textDecoration: 'underline'
        }
    },
    statusText: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'rgba(255, 255, 255, 0.1)',
        fontSize: theme.typography.pxToRem(200),
        fontWeight: 'bold',
        zIndex: 1,

        [theme.breakpoints.up('md')]: {
            fontSize: theme.typography.pxToRem(300)
        },

        [theme.breakpoints.up('lg')]: {
            fontSize: theme.typography.pxToRem(400)
        },

        [theme.breakpoints.up('xl')]: {
            fontSize: theme.typography.pxToRem(500)
        }
    },
    message: {
        maxWidth: '75%',
        margin: theme.spacing(8, 'auto'),
        fontWeight: 400,
        textAlign: 'center',
        [theme.breakpoints.up('lg')]: {
            fontSize: theme.typography.pxToRem(50)
        }
    },
    backButton: {
        margin: 'auto'
    }
}));

export default useStyles;
